import { LocaleLowerCase } from './types/locale'

export enum Route {
  ProductList = '/products/',
  YourCart = '/cart/',
  CustomerInfo = '/customer-info/',
  PaymentCheckout = '/payment/',
  SuccessPage = '/payment-success/',
}

export type FullRoute = `/${LocaleLowerCase}${Route}`
